<template>
	<ul>
		<li v-for="item in items" :key="item.filename">
			<nuxt-link :to="item.filename">
				{{ item.header }}
			</nuxt-link>
			<div v-if="item.children.length">
				<recursive-sitemap :items="item.children" />
			</div>
		</li>
	</ul>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
ul div {
	padding-left: 25px;
}
</style>
